/* Decisions implementations as functions */

import HTTP from "./http.service";
import Plans from "./plans.service";
import Numbers from "./numbers.service";
import Storage from "./storage.service";
import Helpers from "../helpers/shared.helper";
import * as variables from '../variables';
import { isArray } from "rxjs/internal-compatibility";

var Summaries = {
	vars: {
		tick: 0,
		loading: false,
		loadingExtras: false,
		prices: {
			number: 0,
			plan: 0,
			vat_percentage: 0
		}
	}
};

Summaries.calculateTotalPrice = () => {
	let total_no_vat = 0;
	let vat_value = 0;
	let total_with_vat = 0;
	let summary = Storage.get("summary");

	if (summary) {
		let reservedNumber = summary["reserved_number"];
		let selectedPlan = summary["selected_bundle"];

		if (reservedNumber && selectedPlan && summary["prices"]) {
			let plan_price = summary["prices"]["plan"];
			let number_price = summary["prices"]["number"];
			total_no_vat = plan_price + number_price;
			let vat = summary["prices"]["vat_percentage"];
			let vat_percentage = parseFloat(vat, 10) / 100;
			total_with_vat = total_no_vat * (1.0 + vat_percentage);
			vat_value = total_no_vat * vat_percentage;
		}
	}
	return {
		total_no_vat: Helpers.formatNumber(total_no_vat),
		total_with_vat: Helpers.formatNumber(total_with_vat),
		vat_value: Helpers.formatNumber(vat_value)
	};
}

Summaries.isTotalPricesReady = () => {
	let summary = Storage.get("summary");
	if (summary) {
		let reservedNumber = summary["reserved_number"];
		let selectedPlan = summary["selected_bundle"];
		if (reservedNumber && selectedPlan && summary["prices"]) {
			Helpers.debug_payment("prices ready");
			return true;
		}
	}
	return false;
}

Summaries.getSummary = (callee = 'default') => {
	let tempSumamry = Storage.get("summary");
	tempSumamry = { ...tempSumamry, loadingOffers: true }
	Storage.set("summary", tempSumamry);

	let offerAppliedPromoId = Storage.get("offer_applied_promotion_id", true);

	let config = {
		method: "get",
		url: "/plans/summary?include_optional_promotions=true&random=" + Date.parse(new Date()),
		headers: {
			// "accept-version": "v18",
			"cache-control": "no-cache"
		}
	};
	if (offerAppliedPromoId?.length) {
		let promotionID = isArray(offerAppliedPromoId) ?
            offerAppliedPromoId.join(",") :
            offerAppliedPromoId;
		config = {
			method: "get",
			url: "/plans/summary?include_optional_promotions=true&random=" + Date.parse(new Date()) + "&promotion_codes=" + promotionID,
			headers: {
				// "accept-version": "v18",
				"cache-control": "no-cache"
			}
		};
	}
	// return HTTP(config);


	if (Storage.get("fetching_summary")) {
		return Storage.get("fetching_summary");
	}

	if (Storage.get('fetching_summary')) {
		Storage.set("fetching_summary", false);
		return HTTP(config);
	} else {
		let f = HTTP(config);
		Storage.set("fetching_summary", f);
		f.then(res => {
			Storage.set("fetching_summary", false);
		}).catch(err => {
			Storage.set("fetching_summary", false);
		});
		return f;
	}

};

Summaries.getPlan = () => {
	return Plans.getSavedBundle(2);
};


Summaries.deleteExtra = (extra, should_call_summary) => {

	if (!extra) return;


	let extraValue =

		extra === 'anghami' ? variables.PROMOTION_TYPE_ANGHAMI : extra === 'starzplay' ? variables.PROMOTION_TYPE_STARZPLAY :

			extra === 'osn' ? variables.PROMOTION_TYPE_OSN : extra === 'ufc' ? variables.PROMOTION_TYPE_UFC :

				extra === 'discovery' ? variables.PROMOTION_TYPE_DISCOVERY : variables.PROMOTION_TYPE_BLUTV;



	let jsonObjectExtras = [{ // all of Extras should be added one by one - in different API call

		Value: extraValue, // ANGHAMI ,  STARZPLAY , OSN, UFC , Discovery ,  BluTV

		Type: variables.CONTENT_SERVICE_TYPE

	}];


	return Plans.deletePlanExtra(jsonObjectExtras).then(res => {

		if (should_call_summary) {

			Plans.getPlanExtrasSummary().then(res_extras_summary => { // get Extras Summary because in plans/summary extras are always empty array []
				Summaries.vars["extras"] = res_extras_summary.data.extras;

				Summaries.getSummary('init').then(res_plan_summary => { // because we need to get total price of Summaries after delete of extras
					// Added plan Extra summary for calculating correct total including service provider price
					Summaries.vars["prices"]["vat_amount"] = res_plan_summary.data.vat_amount + res_extras_summary.data.vat_amount;
					Summaries.vars["prices"]["total_amount_vat_excluded"] = res_plan_summary.data.total_amount_vat_excluded;
					Summaries.vars["prices"]["total_amount_vat_included"] = res_plan_summary.data.total_amount_vat_included + res_extras_summary.data.total_cost;

					Storage.set("summary", Summaries.vars);
				}).catch(el => {
					console.log('error in getPlanExtrasSummary', el);
				});
			}).catch(el => {
				console.log('error in getPlanExtrasSummary', el);
			});

			// get Extras Summary from /extras because in /plans/summary API extras are always empty array []

			// return Plans.getPlanExtrasSummary().then(res => {

			// 	Summaries.vars["extras"] = res.data.extras;

			// 	Storage.set("summary", Summaries.vars);

			// });

		}

	});

};

Summaries.updateStreamExtras = (extra) => {

	if (!extra) return;

	let extraValue =

		extra === 'anghami' ? variables.PROMOTION_TYPE_ANGHAMI : extra === 'starzplay' ? variables.PROMOTION_TYPE_STARZPLAY :

			extra === 'osn' ? variables.PROMOTION_TYPE_OSN : extra === 'ufc' ? variables.PROMOTION_TYPE_UFC :

				extra === 'discovery' ? variables.PROMOTION_TYPE_DISCOVERY : variables.PROMOTION_TYPE_BLUTV;



	let jsonObjectExtras = [{ // all of Extras should be added one by one - in different API call

		Value: extraValue, // ANGHAMI ,  STARZPLAY , OSN, UFC , Discovery ,  BluTV

		Type: variables.CONTENT_SERVICE_TYPE

	}];


	return Plans.postPlanExtras(jsonObjectExtras);

};

Summaries.init = (callee = 'default') => {

	if (!Storage.get("PredefinedPlans") || !Storage.get("AvailablePlans")) {
		Plans.getPlans("Available");
	}

	Storage.get_obsrv("vanity_details").subscribe(async data => {
		Summaries.vars["vanity_details"] = data;

		Storage.set("summary", Summaries.vars);

		if (data) {

			Storage.get_obsrv("AvailablePlans").subscribe(AvailablePlans => {
				if (AvailablePlans) {
					Plans.getPlans("Predefined");
				}
			});

			// get Extras Summary from /extras because in /plans/summary API extras are always empty array []

			await Plans.getPlanExtrasSummary().then(res => {

				Summaries.vars["extras"] = res.data.extras;

			});

			Storage.get_obsrv("PredefinedPlans").subscribe(PredefinedPlans => {
				if (PredefinedPlans) {

					let flags = Storage.get('flags');
					if (flags) {

						if (flags.NumberSelected || flags.SIMActivated) {
							// Storage.set("summary_offer_update", true)
							return Summaries.getSummary('init')
								.then(response => {

									// Storage.set("summary_offer_update", false)
									Summaries.vars["prices"]["vat_amount"] = response.data.vat_amount;
									Summaries.vars["prices"]["total_amount_vat_excluded"] = response.data.total_amount_vat_excluded;
									Summaries.vars["prices"]["total_amount_vat_included"] = response.data.total_amount_vat_included;
									Summaries.vars["commitment"] = response?.data?.plan_commitment_period;
									//Summaries.vars["extras"] = response.data.extras;
									if (response.data.number_details) {
										let number = response.data.number_details;
										Storage.set("reserved_number", number);

										Summaries.vars["reserved_number"] = number;

										let vanity_details = Summaries.vars["vanity_details"];
										if (vanity_details) {

											let VanityLevel = Numbers.getVanityLevelID(number);

											let detail = vanity_details["" + VanityLevel];
											detail["is_vanity_plan"] = true;

											let vanity_plan = Plans.getSinglePlanWithSpecs(detail);
											let price = detail["vanityPrice"];
											Summaries.vars["prices"]["number"] = price;

											Summaries.vars["vanity_plan"] = vanity_plan;

											Summaries.vars["vanity"] = detail;
										}
									}

									if (
										response.data.saved_plans &&
										response.data.saved_plans[0] &&
										response.data.saved_plans[0]["Plans"] &&
										response.data.saved_plans[0]["Plans"].length
									) {

										let selected_bundle = Plans.getSinglePlanWithSpecs(
											response.data.saved_plans[0]
										);
										Storage.set("selectedPlanSpecsIDs",
											Plans.getPlanIDs(response.data.saved_plans[0])?.split(',').sort().join(','));
										Storage.set("selectedPlanPromotions", response.data.saved_plans[0]?.PlanPromotions);
										if (selected_bundle.ProductCode)
											Storage.set("selectedProduct", selected_bundle.ProductCode);

										let PredefinedPlans = Storage.get("PredefinedPlans");
										if (PredefinedPlans) {
										}

										let type = Plans.findPlanType(
											PredefinedPlans,
											selected_bundle
										);
										selected_bundle["bundle_type"] = type;

										Storage.set("selected_bundle", selected_bundle);

										Summaries.vars["selected_bundle"] = selected_bundle;
										Summaries.vars["selectedPlanPromotions"] = response.data.saved_plans[0]?.PlanPromotions

										Summaries.vars["prices"]["plan"] =
											selected_bundle["DiscountedPrice"];
										let business = JSON.parse(Storage.get('business', true));
										Summaries.vars["prices"]["vat_percentage"] =
											business["vat_percentage"];
										Summaries.vars["prices"]["OriginalPrice"] = response.data.saved_plans[0]["OriginalPrice"];
									} else {
										if (flags.PlanSelected) {
											// @Todo print PAYG plan specs
											Storage.set("selected_bundle", []);
											Summaries.vars["selected_bundle"] = [];
										} else {
											Storage.set("selected_bundle", null);
											Summaries.vars["selected_bundle"] = null;
										}
									}

									Summaries.vars["tick"] = Summaries.vars["tick"] + 1;
									Storage.set("summary", Summaries.vars);
								})
								.catch(err => { });
						}
					}
					// })

				}
			});
		}
	});



	// Numbers.vanity_details();

	// Storage.getOrfetch("vanity_details", Numbers.vanity_details)
	// 	.then(data => {
	// 		if (data["data"]) {
	// 			Numbers.process_vanity_details(data.data);
	// 		}
	// 	})
	// 	.catch(error => { });
};

export default Summaries;